import { MOTIVATION_TO_CHANGE } from '@app/models/Common';
import { ICON_NAMES } from '@reverse-hr/design-system';

export const MOTIVATION_TO_CHANGE_TO_ICONS_MAP = {
  [MOTIVATION_TO_CHANGE.LOW]: ICON_NAMES.CONFUSED,
  [MOTIVATION_TO_CHANGE.MEDIUM]: ICON_NAMES.HAPPY,
  [MOTIVATION_TO_CHANGE.HIGH]: ICON_NAMES.SUPER_HAPPY,
};
